module.exports = __webpack_public_path__ + "img/filter-arrow.48c59c09.svg";